<shared-core-header (logoClicked)="onLogoClicked()">
  <div class="flex items-center gap-3">
    <ct-shared-proof-batch-details [ctBatch]="proofCtBatch()" />
    <ct-shared-comment-button
      (clicked)="setChatMessagePopupOpened(!derivedIsChatMessagePopupOpened())"
      [isChatPopupOpened]="derivedIsChatMessagePopupOpened()"
      provideNativeElement
      #chatDisplayTrigger="element"
      [doMessagesExist]="doMessagesExist()" />
    @if (derivedIsChatMessagePopupOpened()) {
      <ct-shared-chat-display
        class="shadow-floating-container absolute z-100 flex max-h-[35vh] w-128 flex-col gap-3 rounded-lg bg-white p-3"
        floatingElement
        [messages]="messages()"
        [isOpened]="derivedIsChatMessagePopupOpened()"
        (closePopup)="setChatMessagePopupOpened(false)"
        [anchor]="chatDisplayTrigger"
        [placement]="'bottom-start'"
        [offsetConfig]="{ main: 10 }" />
    }
    <button class="border-theme-gray-500 gap-3 rounded-md border p-1" (click)="openProofForBatch()">
      PROOF
    </button>
    @if (configService.config.devToolsEnabled) {
      <button (click)="isSettingsToggled.set(!isSettingsToggled())" #settingsAnchor>
        <shared-core-material-icon name="settings" />
      </button>
      <shared-core-floating-menu
        [isOpened]="isSettingsToggled()"
        class="shadow-floating-container fixed z-10000 flex flex-col rounded-md bg-white p-3"
        [ngClass]="{ hidden: !isSettingsToggled() }"
        [anchor]="settingsAnchor">
        <shared-core-floating-menu-item class="flex items-center gap-3">
          Maximale Anzahl Seiten im Speicher:
          <input
            [(ngModel)]="_setMaxStoredImages"
            size="4"
            type="number"
            class="rounded-md border border-gray-200 p-1.5" />
        </shared-core-floating-menu-item>
        <shared-core-floating-menu-item class="flex items-center gap-3">
          (0.5 * ) Größe des tolerierten geladenen Intervalls:
          <input
            [(ngModel)]="_setHalfToleratedWindow"
            size="4"
            type="number"
            class="rounded-md border border-gray-200 p-1.5" />
        </shared-core-floating-menu-item>
        <shared-core-floating-menu-item class="flex items-center gap-3">
          (0.5 * ) Größe nachgeladener Intervalls:
          <input
            [(ngModel)]="_setHalfLoadWindow"
            size="4"
            type="number"
            class="rounded-md border border-gray-200 p-1.5" />
        </shared-core-floating-menu-item>
        <shared-core-floating-menu-item>
          <button
            class="rounded-md border border-gray-300 p-3"
            (click)="updatePrioritizerSettings()">
            Übernehmen
          </button>
        </shared-core-floating-menu-item>
      </shared-core-floating-menu>
    }
  </div>
</shared-core-header>
